module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "EventListItemPartialView",
    on: {
      "click": _vm.openEvent
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.event.name))]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(_vm.regionName) + "\n  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.event.startDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.event.endDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.typeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusName))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "multiCopy",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.multiCopyEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "copy"
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "arrow-right"
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "map-marker"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "copy",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.copyEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "copy"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "delete",
    attrs: {
      "variant": "secondary",
      "disabled": _vm.event.isLocked || _vm.event.isConfirmed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.event.isLocked),
      expression: "!event.isLocked"
    }],
    staticClass: "lock",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "variant": "secondary",
      "disabled": !_vm.event.isConfirmed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lockEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "unlock"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.event.isLocked),
      expression: "event.isLocked"
    }],
    staticClass: "unlock",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "variant": "secondary",
      "disabled": !_vm.event.isConfirmed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unlockEvent($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "lock"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-61c6159d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EventList/EventListItem.vue
// module id = 1691
// module chunks = 1